import { useMemo } from 'react';
import { encrypted, tokenManager } from '../utils/utility';

/**
 * Custom hook to access encrypted logged in user details and tokens from localStorage
 * @returns {Object} Object containing user data, tokens, and utility functions
 */
export const useAuth = () => {
  const userData = useMemo(() => {
    try {
      const encryptedData = localStorage.getItem("LoggedInDetails");
      if (!encryptedData) return null;

      const decryptedData = encrypted.decrypt(encryptedData);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error("Error decrypting user data:", error);
      return null;
    }
  }, []);

  const getUserField = (key) => {
    if (!userData) return null;
    return userData[key] || null;
  };

  // Token management functions
  const getToken = (tokenKey = "token") => tokenManager.getToken(tokenKey);
  const setToken = (tokenValue, tokenKey = "token") => tokenManager.setToken(tokenValue, tokenKey);
  const removeToken = (tokenKey = "token") => tokenManager.removeToken(tokenKey);

  const isLoggedIn = () => {
    return !!userData && !!getToken("token");
  };

  return {
    userData,
    getUserField,
    isLoggedIn,
    // Token management
    getToken,
    setToken,
    removeToken,
    // Common fields for convenience
    userId: getUserField('user_id'),
    username: getUserField('username'),
    fullName: getUserField('full_name'),
    email: getUserField('email'),
    role: getUserField('role'),
    team: getUserField('team'),
    ugdnId: getUserField('ugdn_id'),
    // Common tokens for convenience
    token: getToken("token"),
    procurementToken: getToken("procurementToken"),
    GMTToken: getToken("GMTToken"),
  };
};
